import React from "react";
import "./Start.scss";

export default function Start() {


    return(<div className="start">
         <h2>Välkommen hit!</h2> 
         <p>Det här är en samlingsplats 
            för kristna sammankomster runt om i Sverige 
            för alla oss som bekänner Jesus Kristus som Herre.
        </p>
        <p>I kalendern får du enkelt en överblick över vad som händer där du bor (eller i andra delar i Sverige).
            Om du loggar in kan du även lägga till händelser som du känner till, 
            hålla koll på andra användare och mycket mer!
        </p>
        <p>Kalendern fylls av oss användare och tillsammans skapar vi fler möjligheter 
            att mötas utanför våra sociala bubblor, hitta nya likasinnade och samla våra krafter 
            till de initiativ vi vill ta som Guds folk.</p>
        <p>... och du som ännu inte är kristen är självklart lika välkommen hit!</p>
        <p className="contact-info">kontakt: hoppetsfolk@gmail.com</p>
    </div>)
}